import React from 'react';
import { Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import {personFullName} from "../../../../services/Api";
import SelectAsync from 'react-select/lib/Async';
import _ from "lodash";
import PropTypes from "prop-types";

class AddEventAttendanceModal extends React.Component{

    static contextTypes = { api:PropTypes.object, notifier: PropTypes.object };

    constructor( props ){
        super(props);
        const person = props.person;
        this.state = {
            form: {
                member: personFullName(person)
            }
        };
        this.loadEvents = _.debounce(this.loadEvents, 250);
    }

    onFormChange = ({target})=> this.setState(  { form:{...this.state.form, [target.name]:target.value}} );

    loadEvents = ( name )=>{
        return this.context.api.events.get( 0, 10, undefined, {name:name})
            .then( (events=[])=> events.map( (event)=>({value:event.id, label: event.name }) ) ) };

    getFormValue = ( name )=>{
        return this.state.form[name]? this.state.form[name]:'';
    };

    saveAttendance = () =>{
        if(!this.state.form.event) return this.context.notifier.error('Debes introducir el evento o taller a asignar');
        const attendance = {"person":this.props.person.id,"event":this.state.form.event.value};
        this.context.api.eventAttendances.create( attendance, undefined).then(this.finish);
    };

    finish = ()=>{
        if( this.props.didSave ) {this.props.didSave();}
        this.props.onHide();
    };

    render(){

        const { onHide } = this.props;

        return (
            <Modal show={true}
                   onHide={ onHide }>
                <Modal.Header closeButton>
                    <Modal.Title>{'Añadir evento o taller a miembro'}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <p><b>Miembro:</b> {this.getFormValue('member')}</p>
                    <SelectAsync
                        cacheOptions
                        placeholder='Nombre del evento o taller'
                        noOptionsMessage={()=>"Sin coincidencias"}
                        loadOptions={this.loadEvents}
                        onChange={(value)=>this.onFormChange({target:{name:"event", value}})}
                        value={ this.getFormValue('event') }
                    />
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={ this.props.onHide } className='btn btn-primary pull-left'>Cancelar</button>
                    <button className='btn btn-danger' onClick={this.saveAttendance}>Añadir</button>
                </Modal.Footer>
            </Modal>
        );
    }
}

const mapStateToProps = ( { api:{events=[], eventsMeta={},simplePeople=[]}, loadingIds } )=>({simplePeople, events, eventsMeta, loadingIds});

export default connect(mapStateToProps)(AddEventAttendanceModal);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/AddEventAttendanceModal/index.jsx